import "./instrument";
import React from "react";
import ReactDOM from "react-dom/client";
import { ApolloProvider } from "@apollo/client";
import { PostHogProvider } from "posthog-js/react";
import { CaptureResult, PostHogConfig } from "posthog-js";
import graphQLClient from "./apollo-client";
import App from "./app";
import "@/styles/_globals.scss";

const options = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  capture_pageview: false,
  before_send(event: CaptureResult | null) {
    if (
      event?.event === "$exception" &&
      window.location.hostname === "localhost"
    ) {
      return null;
    }
    return event;
  },
} as Partial<PostHogConfig>;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={options}
    >
      <ApolloProvider client={graphQLClient}>
        <App />
      </ApolloProvider>
    </PostHogProvider>
  </React.StrictMode>,
);
